var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"wind--text wa--name-value"},[_c('strong',[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('span',{staticClass:"wind--text-divider"}),_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }